// frontend/src/pages/Home.js
import { Link } from "react-router-dom";
import { FaSteam } from "react-icons/fa";

import PageContainer from "../components/layout/PageContainer";
import GlassPanel from "../components/layout/GlassPanel";

import HeroVideo from "../components/home/HeroVideo";
import MonthlyGoal from "../components/home/MonthlyGoal";
import ContentTabs from "../components/home/ContentTabs";

import FloatingSocialBar from "../components/layout/FloatingSocialBar";

import logo from "../assets/images/logo.png";

import {
  trackEvent,
  trackSocialClick,
  trackSupportClick,
} from "../analytics/analytics";

export default function Home() {
  function handleSteamClick() {
    trackEvent("STEAM_CLICK", {
      source: "home_cta",
      href: "https://store.steampowered.com/app/3907080/Elacoria?utm_source=elacoria_website",
    });
  }

  function handleSupportClick() {
    trackSupportClick("home_cta");
  }

  return (
    <PageContainer>
      <div className="home-shell">
        <div className="home-logo-wrap">
          <img src={logo} alt="Elacoria" className="home-logo" />
        </div>

        {/* <MonthlyGoal /> */}

        <div className="home-panel-wrap">
          <GlassPanel>
            <HeroVideo />

            <div className="cta-row">
              <a
                href="https://store.steampowered.com/app/3907080/Elacoria?utm_source=elacoria_website"
                target="_blank"
                rel="noreferrer"
                className="play-button"
                onClick={handleSteamClick}
              >
                <FaSteam size={36} />
                PLAY NOW
              </a>

              <Link to="/support" onClick={handleSupportClick}>
                <button className="preorder-button">BACK ELACORIA</button>
              </Link>
            </div>

            <ContentTabs />
          </GlassPanel>

          <FloatingSocialBar />
        </div>
      </div>
    </PageContainer>
  );
}
